"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealerSummaryStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return ({
        dealerSummary: {},
        dealerName: {
            textTransform: 'uppercase',
            color: palette.common.black,
        },
        dealerAddress: {},
        dealerItem: {},
    });
}, { name: 'Checkout4_DealerSummary' });
exports.default = dealerSummaryStyles;
